import { getConfig } from '../../../config';

const config = await getConfig();
export const apiBase = config.RDARR_APP_URL ? `${config.RDARR_APP_URL}/api` : '/api';
